import authService from "@/services/auth/auth.service";
const departmentsRoutes = [
  {
    path: "/registries/departments",
    name: "DepartmentsRegistryNewForm",
    component: () => import("@/components/areas/registries/departments/DepartmentsRegistryNewForm.vue"),
    props: (route) => {
      return {
        openDialog: true,
        pathToGoBack: route.query.pathToGoBack,
        tabName: route.query.tabName || 'registry'
      }
    },
    beforeEnter: (to, from, next) => {
      authService.redirectIfLicenseBlocked()
      next()
    }
  },
  {
    path: "/registries/departments/:id/edit",
    name: "DepartmentsRegistryEditForm",
    component: () => import("@/components/areas/registries/departments/DepartmentsRegistryEditForm.vue"),
    props: (route) => {
      return {
        openDialog: true,
        pathToGoBack: route.query.pathToGoBack,
        pathName: route.query.pathName,
        tabName: route.query.tabName || 'registry',
        filters: route.params.filters
      }
    },
  },
  {
    path: "/registries/departments/list",
    name: "DepartmentsRegistryList",
    component: () =>
      import(
        "@/components/areas/registries/departments/DepartmentsRegistryList.vue"
      ),
    props: (route) => {
      return {
        filters: route.params.filters
      }
    }
  }
];

export default departmentsRoutes;